<!-- Container -->
<div class="container">

  <ul>
    <li class="help-ul">
      For any additional questions, there are two options for contacting us:
      <ul>
        <li>
          Submit a help request from the app
          (Choose "Use the Help Form" under the Help section in the main menu)
        </li>
        <li>
          Email
          <a [href]="'mailto:' + email">
            {{email}}
          </a>
        </li>
      </ul>
    </li>
  </ul>

</div>
